import '../../css/styles.css'
import '../../css/components/buttons.css'
import '../../css/components/sheet-layout.css'

import { SidebarToggle } from '../../utils'
import { Menu, Header } from '../../components'

import { Home } from './Home'
import { /*OrderExcel,*/ DeliverInfo, DeliveryArea, DeliveryRecord, OrderInfo, OrderRule, ReceiptForm, Schedule, VehicleManagement, LogViewer, TruckLoanApprovalPage } from '../../sections'

import { Navigate, Route, Routes } from 'react-router-dom'
import { StaffOrderInfo } from '../StaffOrderInfo/StaffOrderInfo'
import { navigationConfig } from '../../constants/navigationConfig'
import { RoleGuard } from '../../components/RoleGuard/RoleGuard'

const SKAManager = () => {
    SidebarToggle();

    // 組件映射表
    const componentMap = {
        'Home': Home,
        'Schedule': Schedule,
        'ReceiptForm': ReceiptForm,
        'OrderRule': OrderRule,
        'OrderInfo': OrderInfo,
        'DeliverInfo': DeliverInfo,
        'DeliveryRecord': DeliveryRecord,
        'DeliveryArea': DeliveryArea,
        'VehicleManagement': VehicleManagement,
        'StaffOrderInfo': StaffOrderInfo,
        'LogViewer': LogViewer,
        'TruckLoanApprovalPage': TruckLoanApprovalPage,
    };

    // 從 navigationConfig 生成路由
    const routes = [];
    navigationConfig.forEach((item) => {
        if (item.componentName && !item.items) {
            routes.push({
                path: item.path,
                component: componentMap[item.componentName],
                requiredRole: item.requiredRole,
            });
        }

        if (item.items && Array.isArray(item.items)) {
            item.items.forEach((subItem) => {
                if (subItem.componentName) {
                    routes.push({
                        path: subItem.path,
                        component: componentMap[subItem.componentName],
                        requiredRole: subItem.requiredRole,
                    });
                }
            });
        }
    });

    return (
        <>
            <Header />
            <div id="layoutSidenav">
                <Menu />
                <div id="layoutSidenav_content">
                    <Routes>
                        {/* 動態生成路由 */}
                        {routes.map((route) => {
                            // 如果有 requiredRole，用 RoleGuard 包裝
                            if (route.requiredRole) {
                                return (
                                    <Route
                                        key={route.path}
                                        path={route.path}
                                        element={
                                            <RoleGuard requiredRole={route.requiredRole}>
                                                <route.component />
                                            </RoleGuard>
                                        }
                                    />
                                );
                            }
                            return (
                                <Route key={route.path} path={route.path} element={<route.component />} />
                            );
                        })}
                        {/* 默認路由 */}
                        <Route path="" element={<Navigate to="/SKAManager/Home" replace />} />
                    </Routes>
                </div>
            </div>
        </>
    )
}

export { SKAManager }